export function StringSort(stringA: string, stringB: string): number {
  return stringA.localeCompare(stringB);
}

export function NumberSort(numberA: number, numberB: number): number {
  return numberA - numberB;
}

export function TemporalSort<
  T extends { compareTo: (otherTemporal: T) => number },
>(temporalA: T, temporalB: T): number {
  return temporalA.compareTo(temporalB);
}

export function BooleanSort(booleanA: boolean, booleanB: boolean): number {
  if (booleanA === booleanB) {
    return 0;
  } else if (booleanA) {
    return 1;
  } else {
    return -1;
  }
}
